import { render, staticRenderFns } from "./EscalaMovimentacoes.vue?vue&type=template&id=229d7c3a&"
import script from "./EscalaMovimentacoes.vue?vue&type=script&lang=js&"
export * from "./EscalaMovimentacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports